export default __webpack_public_path__ + "static/media/logoCardBack.616863ec.svg";